import React from 'react';
import { Skeleton } from '../../ComponentsV1/Skeleton/Skeleton';

const skeletonRows = [
  { cols: 2, height: '7rem' },
  { cols: 3, height: '10rem' },
  { cols: 1, height: '14rem' },
];

const Loader = () => {
  return <Skeleton rows={skeletonRows} className='tw-mt-6' />;
};

export { Loader };
